export default {
  test_value: "US Test value"
};
